import React from "react";
import { Circle, CircleDot, AlertTriangle, Cloud } from "lucide-react";

const MAP = {
  live: { label: "Live", cls: "bg-emerald-500/15 text-emerald-400", icon: CircleDot },
  delayed: { label: "Delayed", cls: "bg-amber-500/15 text-amber-300", icon: Circle },
  partial: { label: "Partial", cls: "bg-amber-500/15 text-amber-300", icon: AlertTriangle },
  stale: { label: "Stale", cls: "bg-zinc-500/15 text-zinc-400", icon: Cloud },
  unavailable: { label: "Unavailable", cls: "bg-rose-500/15 text-rose-400", icon: AlertTriangle },
  demo: { label: "Demo Data", cls: "bg-orange-500/15 text-orange-400", icon: AlertTriangle },
  estimated: { label: "Estimated", cls: "bg-blue-500/15 text-blue-300", icon: Circle },
};

export default function DataQualityBadge({ status = "live", testid }) {
  const m = MAP[status] || MAP.unavailable;
  const Icon = m.icon;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[10px] uppercase tracking-wider ${m.cls}`}
    >
      <Icon size={10} /> {m.label}
    </span>
  );
}
